import { useState } from 'react'

import { FetchMeetingRequest, meetingApi } from '../api'

const useFetchMeeting = () => {
  const [isFetching, setIsFetching] = useState(false)

  const fetchMeeting = async (data: FetchMeetingRequest) => {
    setIsFetching(true)
    try {
      const meeting = await meetingApi.fetchMeeting(data)
      return meeting
    } catch (error) {
      console.error('Failed to create meeting', error)
      return null
    } finally {
      setIsFetching(false)
    }
  }
  return { isFetching, fetchMeeting }
}
export default useFetchMeeting
